import ReactGA from 'react-ga';

// TODO: Deprecate this file once FAQ is migrated to Analytika V2

enum Categories {
  connection = 'cnx_connection',
  delivery = 'cnx_delivery',
  queuedDelivery = 'cnx_queuedDelivery',
  otp = 'cnx_otp',
  createDelivery = 'cnx_create_delivery',
  faqAnswer = 'cnx_faq_answer',
  dispute = 'dispute',
  walletInvoice = 'wallet_invoice'
}

enum Actions {
  listen = 'listen',
  impression = 'impression',
  click = 'click',
  offline = 'offline',
  created = 'created',
  attemptToCreate = 'attemptToCreate',
  attemptToRecreate = 'attemptToRecreate',
  recreated = 'recreated',
  failed = 'failed',
  like = 'like',
  dislike = 'dislike',
  fetched = 'fetched'
}

enum Dimensions {
  valueData = 'dimension1',
  sessionId = 'dimension2',
  timestamp = 'dimension3',
  customerId = 'dimension4'
}

/**
 * This function does two things
 * 1. Defere the passed function `fun` to the next tick in event-loop to not block the main app logic
 * 2. Protect main app from func `fun` if it throws an error, yet to protect the main app logic
 * @param fun any function
 */
const guardFunctionCall = (fun: (...args: any[]) => void) => {
  setTimeout(() => {
    try {
      fun();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }, 0);
};

type ReportEventProps = {
  category: Categories;
  action: Actions;
  label?: string;
  value?: number;
};

const reportEventNoGuard = ({ category, action, label, value }: ReportEventProps) => {
  ReactGA.set({ [Dimensions.timestamp]: new Date().toISOString() });
  ReactGA.event({
    category,
    action,
    value,
    label
  });
};

export const reportEvent = (props: ReportEventProps) =>
  guardFunctionCall(() => {
    reportEventNoGuard(props);
  });

export const reportLikeAnswer = (question: string) => {
  reportEvent({ category: Categories.faqAnswer, action: Actions.like, label: question });
};

export const reportDislikeAnswer = (question: string) => {
  reportEvent({ category: Categories.faqAnswer, action: Actions.dislike, label: question });
};
